import { ItemsMenu } from "../../../interface/index";
import OrderListItems from "./OrderListItems";

interface Props {
  handleEdit: (dt: any) => void;
  handleDelete: (dt: any) => void;
  items: [ItemsMenu];
  data: any;
}

export default function ListItems(props: Props) {
  const { items, handleEdit, handleDelete, data } = props;

  return (
    <>
      {items && (
        <OrderListItems
          items={items}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
          data={data}
        />
      )}
    </>
  );
}
